<template>
  <section class="swap-balance fomo-dashboard-card" aria-labelledby="swap-balance-title">
    <header><div><span>DE LA VENTA AL COBRO</span><h3 id="swap-balance-title">Tu dinero, por estado</h3></div><small>{{ currency }}</small></header>
    <p v-if="!hasAmounts">Cuando tengas ventas confirmadas, aquí verás qué importe está pendiente y cuánto se ha enviado.</p>
    <dl v-else class="swap-balance__rows">
      <div v-for="row in rows" :key="row.key" class="swap-balance__row">
        <dt>{{ row.label }}<small>{{ row.hint }}</small></dt>
        <dd>{{ money(row.value) }}<span class="swap-balance__track" aria-hidden="true"><span :style="{ width: `${Math.max(0, row.value) / maximum * 100}%` }"></span></span></dd>
      </div>
    </dl>
    <small v-if="hasAmounts">«Enviado» indica la salida al destino de cobro. La llegada al banco puede tardar más.</small>
  </section>
</template>
<script>
import '@/styles/fomo-dashboard.css'
export default {
  props: { summary: { type: Object, required: true }, currency: { type: String, default: 'USD' } },
  computed: {
    rows() { return [
      { key: 'held', label: 'Por cobrar', hint: 'Entrega y plazo de protección' },
      { key: 'available', label: 'Disponible', hint: 'Listo para pago' },
      { key: 'reserved_for_payout', label: 'En proceso', hint: 'Pago en preparación' },
      { key: 'paid', label: 'Enviado', hint: 'Al destino de cobro' },
    ].map(row => ({ ...row, value: Number(this.summary[row.key]) || 0 })) },
    maximum() { return Math.max(1, ...this.rows.map(row => Math.max(0, row.value))) },
    hasAmounts() { return this.rows.some(row => row.value !== 0) },
  },
  methods: { money(value) { return new Intl.NumberFormat('es-EC', { style: 'currency', currency: this.currency }).format(value) } },
}
</script>
<style scoped>
.swap-balance{padding:24px;display:grid;gap:20px;font-family:var(--fomo-font-body);color:var(--fomo-dashboard-text)}
.swap-balance header{display:flex;justify-content:space-between;gap:16px;align-items:start}
.swap-balance header span{font-family:var(--fomo-font-label);font-size:10px;letter-spacing:.12em;color:var(--fomo-dashboard-copy)}
.swap-balance h3{margin:6px 0 0;font-family:var(--fomo-font-heading);font-size:24px;color:var(--fomo-dashboard-text);-webkit-text-fill-color:currentColor;text-shadow:none}
.swap-balance small,.swap-balance p{color:var(--fomo-dashboard-copy);font-size:12px;line-height:1.6;margin:0}
.swap-balance__rows{margin:0;display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:24px 32px}
.swap-balance__row{display:grid;grid-template-columns:minmax(0,1fr) auto;align-items:start;gap:12px}
.swap-balance dt{font-size:13px;font-weight:600;color:var(--fomo-dashboard-label)}
.swap-balance dt small{display:block;font-size:11px;font-weight:400;margin-top:4px}
.swap-balance dd{margin:0;font-family:var(--fomo-font-label);color:var(--fomo-dashboard-text);font-size:20px;font-variant-numeric:tabular-nums;text-align:right;min-width:110px}
.swap-balance__track{display:block;margin-top:10px;height:5px;border-radius:8px;background:var(--fomo-border);overflow:hidden}
.swap-balance__track>span{display:block;height:100%;border-radius:inherit;background:var(--fomo-dashboard-label)}
@media(max-width:680px){.swap-balance{padding:20px}.swap-balance__rows{grid-template-columns:1fr;gap:20px}.swap-balance h3{font-size:21px}}
</style>
